<template>
  <article class="font-size-regular global-font-family shadow d-flex flex-column h-100">
    <header class="bg-grey-100 d-flex justify-content-between align-items-start pt-3 pb-5">
      <span class="type-label" :class="`bg-db-${entry.activityColor} color-white fw-400  py-half px-2`">{{
          entry.activity
        }}</span>
      <img v-if="entry.image" :src="entry.image" alt="{{entry.title}} Logo" class="me-1">
    </header>
    <div class=" d-flex flex-column align-items-start justify-content-start flex-grow-1 px-2 py-3">
      <h1 class="h6 fw-600">{{ entry.title }}</h1>
      <p>{{ entry.excerpt }}</p>
      <address aria-label="Locations" class="mb-1"><i class="fas fa-location-dot color-brand-primary"></i> {{ entry.location }}</address>
      <ul aria-label="Areas of expertise" class="list-unstyled d-flex flex-wrap mb-4">
        <li class="bg-grey-100 rounded-1 px-1 me-1 mb-1" v-for="expertise in entry.expertise" :key="expertise">{{expertise}}</li>
        <li v-if="entry.surplusExpertise > 0" aria-label="Number of expertise not listed">+ {{entry.surplusExpertise}} more</li>
      </ul>
      <a :href="entry.url" class="bd-btn bd-btn-ghost-one mt-auto">View Profile</a>
    </div>
  </article>
</template>

<script>
export default {
  name: "EntryCard", props: ['entry'],
}
</script>

<style scoped>
article {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

header {
  height: 128px;
}
.type-label {
  max-width: 140px;
}

img {
  max-width: 140px;
}
</style>